module.exports = __webpack_public_path__ + "price-changed.svg?1f033c6085aff934d13e9c1901f534f3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/price-changed.svg
// module id = 307
// module chunks = 2